import React, {FC} from "react"

import FormattedMessage from "@irati/utils/lang"
import {H2, Body} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import GenericModal from "@irati/ui/src/GenericModal"
import {useTheme} from "@irati/ui/src/global/useTheme"
import Loading from "@irati/ui/src/Loading"
import {hangPromise} from "@irati/utils/promise"

interface Props {
  show: boolean
  onClose: () => void
}

const LoadingResponseModal: FC<Props> = ({show, onClose}) => {
  const theme = useTheme()

  return (
    <GenericModal customWidth={700} hideActions show={show} onHide={onClose}>
      <Flex padding={[6, 3]} margin={[2, 0]}>
        <Loading load={hangPromise()} />
      </Flex>
      <H2 color={theme.colors.success} marginBottom={2} paddingLeft={3}>
        <FormattedMessage id="admin.components.integration.directorySync.hris.upsell.responseModal.fetching.title" />
      </H2>
      <Body marginBottom={2} paddingLeft={3} weight="bold">
        <FormattedMessage id="admin.components.integration.directorySync.hris.upsell.responseModal.fetching.subTitle1" />
      </Body>
      <Body paddingBottom={6} paddingLeft={3}>
        <FormattedMessage id="admin.components.integration.directorySync.hris.upsell.responseModal.fetching.subTitle" />
      </Body>
    </GenericModal>
  )
}

export default LoadingResponseModal
